import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateMotivoPerdaVenda } from './can-activate-motivo-perda-venda';
import { MotivoPerdaVendaComponent } from './motivo-perda-venda.component';
import { MotivoPerdaVendaFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateMotivoPerdaVenda],
                children: [
                    {path: '', component: MotivoPerdaVendaComponent},
                    {path: 'novo', component: MotivoPerdaVendaFormComponent},
                    {path: ':id', component: MotivoPerdaVendaFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateMotivoPerdaVenda
    ]
})
export class MotivoPerdaVendaRoutingModule { }
